export default {
  List: {
    Title: 'Tính chất nguồn kinh phí',
    Dictionary: 'Danh mục',
    Menu: '/ Mục lục ngân sách / Tính chất nguồn kinh phí',

    ReportInfo: {
      reportId: 'BudgetSourcePropertyList',
      reportName: 'Danh mục tính chất nguồn kinh phí',
    },
  },

  Detail: {
    Controls: {
      propertyCode: 'Mã tính chất',
      propertyName: 'Tên tính chất',
    },
  },
};
